module.exports = __webpack_public_path__ + "static/media/icon_view_on.42671d28.svg";